import { ProductV2, formatPriceText } from '@common'

import { useAppSelector } from '../../../../utils/useAppSelector'
import { useLocale } from '../../../locale/useLocale'

const useFormattedPriceTexts = (products: Array<ProductV2>) => {
  const locale = useLocale()
  const market = useAppSelector((state) => state.config.market)
  const currencyCountry = market?.currencyCountry
  const currency = market?.currencyCode

  if (locale && currencyCountry && currency) {
    return products.map((product) => formatPriceText(product.prices[currencyCountry], locale, currency))
  } else {
    return undefined
  }
}

const getTextScalingRatio = (texts: string[]) => {
  const longest = Math.max(...texts.map((t) => t.length))
  return longest > 13 ? 'XXSmall' : longest > 11 ? 'XSmall' : longest > 9 ? 'Small' : undefined
}

export const usePriceTextScalingRatio = (products: Array<ProductV2>) => {
  const texts = useFormattedPriceTexts(products)
  return texts ? getTextScalingRatio(texts) : undefined
}
